<template lang="pug">
#banner
    v-app-bar(
        density="compact"
        flat
        fixed
        v-if="isMobile()"
    )
        v-app-bar-nav-icon(@click="toggleOverlay()")
    v-navigation-drawer(
        rail
        expand-on-hover
        v-bind:permanent="!isMobile()"
        v-bind:model-value="!hidden"
        @update:model-value="handleOverlayInputEvent"
    )
        v-list
            v-list-item(v-for="route in routes" v-bind:key="route.meta.title" v-bind:to="route.path" link v-bind:prepend-icon="route.meta.icon")
                v-list-item-title {{ route.meta.title }}
</template>

<script lang="ts">
import type { Router as VueRouter } from 'vue-router';

export default {
    name: 'Banner',
    data(): Record<string, unknown> {
        const router: VueRouter = this.$router;
        return {
            hidden: true,
            routes: router.getRoutes(),
        };
    },
    mounted(): void {
        this.hidden = this.isMobile();
    },
    methods: {
        toggleOverlay(): void {
            this.hidden = !this.hidden;
        },
        isMobile(): boolean {
            return this.$vuetify.display.mobile;
        },
        handleOverlayInputEvent(isShown: boolean): void {
            this.hidden = !isShown;
        },
    },
};
</script>

<style lang="scss" scoped>
#banner :deep(.v-app-bar) {
    background-color: #121212;
    color: white;
}

#banner :deep(.v-navigation-drawer) {
    background-color: #121212;
    color: white;
}
</style>
